import './VendorForm.css';
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, InputGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import Loader from '../../components/Loader';
import Skeleton from 'react-loading-skeleton';
import * as apicall from '../../components/Apicall';

function VendorForm2({ vendorData, vendor_id, prev, onSubmit }) {
  // console.log("vendorData, vendor_id, prev, onSubmit", vendorData, vendor_id, prev, onSubmit)
  const [loading, setLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [pricingFormdata, setPricingFormdata] = useState([]);
  const [priceError, setPriceError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [months, setMonths] = useState([
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ])

  // console.log("pricingFormdata", pricingFormdata)

  const fetchPricingDetails = async (month) => {
    try {
      setSelectedMonth(month);
      setPricingFormdata([]);

      if (month === 0 || month !== "") {
        let offering_ids = []
        let location_ids = [];

        // for (const file of vendorData.serviceOffering) {
        //   offering_ids += (offering_ids === "" ? "" : ",") + file.id;
        // }
for (const id of vendorData?.serviceOffering) {
          if (id?.id) offering_ids.push(id.id);
        }
        for (const file of vendorData.selectPMlocation) {
          // console.log(vendorData.selectPMlocation, "vendorData.selectPMlocation");
          const ids = file.id.split(","); // Extract individual IDs
          if (ids.length === 2) {  // Ensure it's a valid pair
            location_ids.push(ids);
          }
        }
        const offerings = offering_ids.join(",");

        // Prepare the data object to send to the backend
        const data = {
          vendor_id: vendor_id,
          month: month,
          offerings: offerings,
          locationIds: location_ids
        };

        setSkeletonLoading(true);
        const res = await apicall.post(data, "vendorEditPrice");
        // console.log(res,"res")
        setPricingFormdata(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch services:", error);
    } finally {
      setSkeletonLoading(false);
    }
  };

  const change_price = (type_index, locationId, service_tier, type, value) => {
    // console.log(type_index, locationId, service_tier, type, value)
    setPricingFormdata((prevData) => {
      return prevData.map((item, i) => {
        if (i !== type_index) return item; // Only modify the selected item

        // Find the actual index in priceDetails using LocationId & service_tier
        const updatedPriceDetails = item.priceDetails.map((price) => {
          if (price.location === locationId && price.service_tier === service_tier) {
            return {
              ...price,
              [type === "fixed" ? "fixed_cost" : "unit_cost"]: value, // Update correct field
            };
          }
          return price;
        });

        return { ...item, priceDetails: updatedPriceDetails };
      });
    });
  };


  const submit = async () => {
    var service_offerings_price = [];
    setPriceError("");
    setLoading(true);

    var is_price_valid = true;
    for (const d of pricingFormdata) {
      for (const item of d.priceDetails) {
        if (item.fixed_cost <= 0 || item.unit_cost <= 0) {
          is_price_valid = false;
          setPriceError("Price value must be greater than 0");
          setLoading(false);
        }
      }
    }

    if (is_price_valid) {
      for (const d of pricingFormdata) {
        for (const item of d.priceDetails) {
          var obj = {
            price_id: item.pricing_id,
            service_offering_id: d.id,
            service_tier: item.service_tier,
            fixed_price: item.fixed_cost,
            unit_price: item.unit_cost,
            location:item.location
          }
          service_offerings_price.push(obj)
        }
      }
      var finaldata = {
        month: selectedMonth,
        service_offerings_price: service_offerings_price
      }
      setTimeout(() => {
        setLoading(false);
      }, 10000);
      onSubmit(finaldata)
    }
  }

  useEffect(() => {
    if (vendor_id == 0 || vendor_id == "0") {
      fetchPricingDetails(0);
    }
  }, []);


  return (
    <div className="container vp vp-pm">
      <h3 className='heading'>Fill Offering Prices</h3>

      <p className='label'>Enter the prices for every offering across all months.</p>

      {vendor_id != 0 &&
        <div className="mb-3 d-flex flex-row">
          <label htmlFor="membershipType" className="label mt-2 me-2">Select Month:</label>
          <select
            id="months"
            name="months"
            value={selectedMonth}
            onChange={(e) => { fetchPricingDetails(e.target.value) }}
            className="form-select" style={{ width: '190px' }}
          >
            <option value="">Select a month</option>
            {months.map(plan => (
              <option key={plan.id} value={plan.id}>{plan.name}</option>
            ))}
          </select>
        </div>
      }

      {skeletonLoading ? (
        <Skeleton count={4} height={100} />
      ) : (
        <Formik
          initialValues={{
            standardFixedPrice1BHK: '',
            standardPerKmPrice1BHK: '',
            premiumFixedPrice1BHK: '',
            premiumPerKmPrice1BHK: '',
          }}
          onSubmit={(values) => {
            submit()
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              {pricingFormdata.length > 0 && (
                <Row className="mb-4">
                  {pricingFormdata.map((item, index) => (
                    <Col md={12} key={item.id}>
                      <div className="vp-offering">
                        <div className="vp-offering-head">{item.name}</div>

                        {Object.entries(
  item.priceDetails.reduce((acc, price) => {
    const loc = price.location;  

    if (!acc[loc]) acc[loc] = { from: null, to: null, prices: [] };

    if (price.fromLocation) acc[loc].from = price.fromLocation;
    if (price.toLocation) acc[loc].to = price.toLocation;

    // Store price details in the same location
    acc[loc].prices.push(price);

    return acc;
  }, {})
).map(([loc, locData], locIndex) => (
  <div key={locIndex} className="mb-3" >
    {/* Display correct From-To Location */}
    <h5>{`${locData.from || "N/A"} - ${locData.to || "N/A"}`}</h5>

    {/* Map price details (Ensures only 4 fields per location) */}
    <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
  <Row className="flex-nowrap" style={{ minWidth: "600px" }}>
    {locData.prices.map((price, p_i) => (
      <Col key={p_i} md={6} lg={4} xl={3} style={{ minWidth: "250px" }}>
        <Form.Label className="label">
          {price.service_tier_name} Fixed Price
        </Form.Label>
        <InputGroup className="mb-2">
          <InputGroup.Text>د.إ</InputGroup.Text>
          <Form.Control
            type="number"
            value={price.fixed_cost}
            onChange={(e) =>
              change_price(index, price.location, price.service_tier, "fixed", e.target.value)
            }
          />
        </InputGroup>

        <Form.Label className="label">
          {price.service_tier_name} Per KM Price
        </Form.Label>
        <InputGroup>
          <InputGroup.Text>د.إ</InputGroup.Text>
          <Form.Control
            type="number"
            value={price.unit_cost}
            onChange={(e) =>
              change_price(index, price.location, price.service_tier, "unit", e.target.value)
            }
          />
        </InputGroup>
      </Col>
    ))}
  </Row>
</div>

    {/* {locData.prices.map((price, p_i) => (
      <Row key={p_i}>
         <Col key={p_i} md={6} lg={4} xl={3}>
          <Form.Label className="label">
            Enter {price.service_tier_name} Fixed Price
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>د.إ</InputGroup.Text>
            <Form.Control
              type="number"
              name="standardFixedPrice1BHK"
              value={price.fixed_cost}
              onChange={(e) =>
                change_price(index, price.location, price.service_tier, "fixed", e.target.value)
              }
            />
          </InputGroup>
        </Col>
        <Col md={6}>
          <Form.Label className="label">
            Enter {price.service_tier_name} Per KM Price
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>د.إ</InputGroup.Text>
            <Form.Control
              type="number"
              name="standardPerKmPrice1BHK"
              value={price.unit_cost}
              onChange={(e) =>
                change_price(index, price.location, price.service_tier, "unit", e.target.value)
              }
            />
          </InputGroup>
        </Col>
      </Row>
    ))} */}
  </div>
))}

                      </div>
                    </Col>
                  ))}
                </Row>
              )}

              <div className="d-flex justify-content-center text-danger">{priceError}</div>

              <div className="vf-actions d-flex justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect"
                  onClick={prev}
                >
                  Back
                </button>
                {pricingFormdata.length > 0 && (
                  <button
                    type="submit"
                    className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center"
                  >
                    {loading ? <Loader style={{ height: "30", width: "40" }} /> : (vendor_id != 0 ? "Update" : "Save")}
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      )
      }
    </div >
  );
}

export default VendorForm2;